import { v4 as uuidv4 } from 'uuid';

// 로컬 스토리지 키 상수
const ANONYMOUS_USER_ID_KEY = 'whatquiz_anonymous_user_id';
const ANONYMOUS_MESSAGE_COUNT_KEY = 'whatquiz_anonymous_message_count';
const LOGIN_PROMPT_SHOWN_KEY = 'whatquiz_login_prompt_shown';

/**
 * 익명 사용자 ID를 가져오거나, 없으면 새로 생성
 * @returns {string} 익명 사용자 ID
 */
export const getAnonymousUserId = () => {
  let anonymousUserId = localStorage.getItem(ANONYMOUS_USER_ID_KEY);
  
  if (!anonymousUserId) {
    anonymousUserId = uuidv4();
    localStorage.setItem(ANONYMOUS_USER_ID_KEY, anonymousUserId);
    // 새 사용자는 메시지 카운트 초기화
    resetAnonymousMessageCount();
  }
  
  return anonymousUserId;
};

/**
 * 익명 사용자의 메시지 카운트 가져오기
 * @returns {number} 익명 사용자가 보낸 메시지 수
 */
export const getAnonymousMessageCount = () => {
  const count = localStorage.getItem(ANONYMOUS_MESSAGE_COUNT_KEY);
  return count ? parseInt(count, 10) : 0;
};

/**
 * 익명 사용자의 메시지 카운트 증가
 * @returns {number} 증가된 메시지 수
 */
export const incrementAnonymousMessageCount = () => {
  const currentCount = getAnonymousMessageCount();
  const newCount = currentCount + 1;
  localStorage.setItem(ANONYMOUS_MESSAGE_COUNT_KEY, newCount.toString());
  return newCount;
};

/**
 * 익명 사용자의 메시지 카운트 초기화
 */
export const resetAnonymousMessageCount = () => {
  localStorage.setItem(ANONYMOUS_MESSAGE_COUNT_KEY, '0');
};

/**
 * 로그인 유도 메시지를 표시할 시점인지 확인
 * 사용자가 2개 이상의 메시지를 보낸 경우 로그인 유도 메시지를 표시
 * @returns {boolean} 로그인 유도 메시지를 표시해야 하면 true, 아니면 false
 */
export const shouldShowLoginPrompt = () => {
  // 이미 로그인 유도 메시지가 표시된 적이 있는지 확인
  const promptShown = localStorage.getItem(LOGIN_PROMPT_SHOWN_KEY);
  
  // 메시지 수가 2개 이상인 경우에만 로그인 유도 메시지 표시
  const messageCount = getAnonymousMessageCount();
  
  // 아직 메시지가 표시된 적이 없고, 메시지 수가 2개 이상이면 표시
  return !promptShown && messageCount >= 2;
};

/**
 * 로그인 유도 메시지를 표시한 것으로 기록
 */
export const markLoginPromptAsShown = () => {
  localStorage.setItem(LOGIN_PROMPT_SHOWN_KEY, 'true');
};

/**
 * 익명 사용자 데이터 삭제 (로그인 후 호출)
 */
export const clearAnonymousUserData = () => {
  localStorage.removeItem(ANONYMOUS_USER_ID_KEY);
  localStorage.removeItem(ANONYMOUS_MESSAGE_COUNT_KEY);
  localStorage.removeItem(LOGIN_PROMPT_SHOWN_KEY);
};

/**
 * 익명 사용자 여부 확인
 * @returns {boolean} 익명 사용자면 true, 아니면 false
 */
export const isAnonymousUser = () => {
  return !!(localStorage.getItem(ANONYMOUS_USER_ID_KEY));
}; 